import React from 'react'
import classes from './ShareButtonSocials.module.scss';
import FacebookIcon from 'components/App/SocialIcons/FacebookIcon/FacebookIcon';
import TwitterIcon from 'components/App/SocialIcons/TwitterIcon/TwitterIcon';

function ShareButtonSocials(props){

	return (
		<section className={classes.ShareButtonSocials}>
           	<div className="c-share">
				<input className="c-share__input" type="checkbox" id={ props.socialID}/>
				<label className="c-share__toggler" htmlFor={props.socialID}>
					<span className="c-share__icon"></span>
				</label>

				<ul className="c-share_options">
					<FacebookIcon facebookDescription={props.description} url={props.url} />
					<TwitterIcon twitterDescription={(props.twitterDescription ? props.twitterDescription : props.description)} twitterDescriptionHashtag={''} url={props.url}/>
				</ul>
			</div>
        </section>
		
	)
}

export default ShareButtonSocials
